import React from "react";
import {Link} from "react-router-dom";

import Logo from "../assets/images/Logo.jpg"

const NavBar=()=>{
    return(
        <div id="nav-container">

          <Link to="/" >
          <figure id="logo"> 
                <img src={Logo} alt="Logo failed to load"/>
            </figure>
          </Link>

           <nav>
           <Link to="/services" className="link-container">
           <span className="nav-links" >Services</span>
           </Link>
            
           <Link to="/careers" className="link-container">
           <span className="nav-links" >Careers</span>
           </Link>
        
<Link to="/about-us" className="link-container" >
<span className="nav-links">About Us</span>

</Link>           </nav>

        </div>

    )
}
export default NavBar;